import "./wowPrice.css";

function makeValueElem(value: number, denom: "Copper" | "Silver" | "Gold"): JSX.Element {
    return (
        <span key={denom}>
            {value}
            <span className={`wowPrice${denom} wowPriceIcon`}></span>
        </span>
    );
}

const WowPrice = ({ value, short }: { value: number; short?: boolean }): JSX.Element => {
    const valueParts: JSX.Element[] = [];
    value = Math.round(value);

    if (short) {
        if (value > 10000) {
            valueParts.push(makeValueElem(Math.floor(value / 100) / 100, "Gold"));
        } else if (value > 100) {
            valueParts.push(makeValueElem(value / 100, "Silver"));
        } else {
            valueParts.push(makeValueElem(value, "Copper"));
        }
    } else {
        const gold = Math.floor(value / 10000);
        const silver = Math.floor(value / 100) % 100;
        const copper = value % 100;
        if (gold) valueParts.push(makeValueElem(gold, "Gold"));
        if (silver) valueParts.push(makeValueElem(silver, "Silver"));
        valueParts.push(makeValueElem(copper, "Copper"));
    }

    return <span className="wowPrice">{valueParts}</span>;
};

export default WowPrice;
